<template>
  <base-dialog
    :action="onAction"
    :action-name="'Update'"
    :close="onClose"
    :title="'Update Card'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container v-if="!isLoading">
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  outlined
                  dense
                  v-model="model.card.exp_month"
                  label="Expiry Month"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  dense
                  v-model="model.card.exp_year"
                  label="Expiry Year"
                />
              </v-col>
            </v-row>

            <v-expansion-panels v-model="moreOptions">
              <v-expansion-panel>
                <v-expansion-panel-header>More Options</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.name"
                    label="Cardholder Name"
                  />

                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.address.line1"
                    label="Address Line 1"
                  />

                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.address.line2"
                    label="Address Line 2"
                  />

                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.address.state"
                    label="Province / State"
                  />

                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.address.postal_code"
                    label="Postal Code / ZIP"
                  />

                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.address.city"
                    label="Address City"
                  />

                  <v-text-field
                    outlined
                    dense
                    v-model="model.billing_details.address.country"
                    label="Address Country"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>

      <v-container
        v-if="isLoading"
        fluid
      >
        <v-row>
          <v-col cols="12">
            <v-row
              align="center"
              justify="center"
              style="height: 300px;"
            >
              <v-progress-circular
                :size="100"
                :width="5"
                color="primary"
                indeterminate
              />
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>
<style>
  .v-expansion-panel, .v-expansion-panels {
    box-shadow: none;
  }
</style>
<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: {
    BaseDialog,
  },
  props: {
    isPlatform: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    customerId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isLoading: false,
      model: {
        billing_details: {
          address: {
            city: null,
            country: null,
            line1: null,
            line2: null,
            postal_code: null,
            state: null,
          },
          email: null,
          name: null,
          phone: null
        },
        card: {
          exp_month: null,
          exp_year: null,
        }
      },
      moreOptions: false
    }
  },
  async created() {
    const payload = {
      id: this.id,
    }

    if (this.isPlatform) {
      payload._headers = { 'x-account': '' }
    }

    this.isLoading = true
    const source = await this.getCustomerPaymentMethod(payload)

    // the lazy way for now
    this.model = { ...source }

    this.isLoading = false
  },
  methods: {
    ...mapActions([ 'updateCustomerPaymentMethod', 'getCustomerPaymentMethod' ]),
    onClose() {
      this.$emit('close')
    },
    async onAction() {
      const payload = {
        ...this.model,
        id: this.id,
      }

      if (this.isPlatform) {
        payload._headers = { 'x-account': '' }
      }

      const updatedPaymentMethod = await this.updateCustomerPaymentMethod(payload)
    }
  }
}
</script>
